// Spec §4.3: UI logic hook for LoadingDrawer component
import _ from 'lodash';
import { useRef } from 'react';

/**
 * Supplies the placeholder rows the loading drawer renders while its data is pending. Builds a ref holding five objects with sequential skeletonId values mapped from a lodash range.
 *
 * @returns A ref holding the five skeleton row placeholders.
 */
export const useLoadingDrawer = () => {
  /**
   * Ref holding five placeholder items, each with a sequential skeletonId, used to render skeleton rows in the loading drawer. Built from a range of five mapped to objects.
   *
   * @returns The ref of skeleton row items.
   */
  const dataLoading = useRef(
    _.map(_.range(5), (item) => ({
      skeletonId: item + 1,
    })),
  );

  return { dataLoading };
};
